var _defs, _metadata, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItspecials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "87.171265mm",
    height: "75.940994mm",
    viewBox: "0 0 308.87456 269.08226",
    id: "svg5707",
    inkscapeVersion: "0.91 r13725",
    sodipodiDocname: "IT-Specials-Logo-Paths.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5709"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(-175.56272,-486.39251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16814",
    transform: "matrix(1.3471945,0,0,1.3471945,-269.37195,134.68696)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.02441,-0.128198)",
    id: "g33754-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6416"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 71.185547,30.230469 c -1.28895,0 -2.36359,0.895706 -2.654297,2.095703 l -11.126953,0 c -0.305633,-1.178596 -1.36687,-2.054688 -2.640625,-2.054688 -1.511566,0 -2.738281,1.226716 -2.738281,2.738282 0,1.288783 0.893987,2.363422 2.09375,2.654296 l 0,27.425782 c -1.177989,0.306048 -2.052735,1.369254 -2.052735,2.642578 0,1.511565 1.226716,2.738281 2.738282,2.738281 1.511565,0 2.738281,-1.226716 2.738281,-2.738281 0,-1.273977 -0.87578,-2.337158 -2.054688,-2.642578 l 0,-27.451172 c 0.93864,-0.259457 1.671074,-0.998804 1.916016,-1.94336 l 11.152344,0 c 0.259376,0.938865 1.000563,1.67108 1.945312,1.916016 l 0,27.478516 c -1.17867,0.305582 -2.054687,1.36877 -2.054687,2.642578 0,1.511565 1.226715,2.738281 2.738281,2.738281 1.511565,0 2.738281,-1.226716 2.738281,-2.738281 0,-1.273808 -0.874064,-2.336996 -2.052734,-2.642578 l 0,-27.478516 c 0.944625,-0.244903 1.683889,-0.977328 1.943359,-1.916016 l 11.070313,0 c 0.305633,1.178597 1.366869,2.052735 2.640625,2.052735 1.511565,0 2.738281,-1.226716 2.738281,-2.738281 0,-1.511566 -1.226716,-2.738282 -2.738281,-2.738282 -1.273756,0 -2.334992,0.876092 -2.640625,2.054688 l -11.044922,0 C 73.54897,31.12641 72.47433,30.230469 71.185547,30.230469 Z",
    transform: "matrix(2.9214746,0,0,2.9214746,237.0326,205.16886)",
    id: "path5715-88"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6406"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g6384"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.27542353,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 397.14258,261.19336 c -4.95018,0 -9.00781,4.05764 -9.00781,9.00781 0,4.95018 4.05763,9.00977 9.00781,9.00977 4.95017,0 9.00976,-4.05959 9.00976,-9.00977 0,-4.95017 -4.05959,-9.00781 -9.00976,-9.00781 z m 0,4.27539 c 2.63956,0 4.73437,2.09286 4.73437,4.73242 0,2.63956 -2.09481,4.73438 -4.73437,4.73438 -2.63956,0 -4.73242,-2.09482 -4.73242,-4.73438 0,-2.63956 2.09286,-4.73242 4.73242,-4.73242 z",
    id: "path7212-8",
    "inkscapeConnector-curvature": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16793"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ff0000",
      strokeWidth: 1.5
    },
    id: "g13935",
    transform: "translate(146.51787,18.797378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6161"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 36.146484,75.884766 c -0.337186,0.0205 -0.655795,0.08276 -0.953125,0.179687 -1.189313,0.387726 -2.018991,1.330841 -2.404297,2.40625 -0.385305,1.075406 -0.334817,2.296191 0.259766,3.263672 0.465777,0.757892 1.273973,1.335708 2.41211,1.552734 0.07956,0.487826 0.485887,0.867188 0.996093,0.867188 0.566837,0 1.027344,-0.460507 1.027344,-1.027344 0,-0.566837 -0.460507,-1.025391 -1.027344,-1.025391 -0.442491,0 -0.81274,0.283138 -0.957031,0.675782 -0.98367,-0.195192 -1.631494,-0.687459 -2.015625,-1.3125 -0.499446,-0.812686 -0.551538,-1.877093 -0.212891,-2.822266 0.338644,-0.945177 1.05897,-1.756317 2.082032,-2.089844 0.844521,-0.275319 1.914516,-0.225409 3.183593,0.376954 -0.103979,0.418855 0.05231,0.871299 0.4375,1.113281 0.479984,0.301526 1.112534,0.157721 1.414063,-0.322266 0.301526,-0.479984 0.157721,-1.114486 -0.322266,-1.416015 -0.421007,-0.26448 -0.947591,-0.169559 -1.277344,0.177734 -0.966092,-0.46223 -1.856963,-0.64543 -2.642578,-0.597656 z m 0.441407,2.8125 c -0.563147,-0.06457 -1.074106,0.339196 -1.138672,0.902343 -0.06456,0.563151 0.34115,1.074109 0.904297,1.138672 0.442809,0.05077 0.84307,-0.193875 1.029296,-0.572265 1.053544,0.313175 1.721914,0.899775 2.085938,1.589843 0.46495,0.881394 0.439205,1.953413 0.02148,2.857422 -0.41772,0.904009 -1.216419,1.629075 -2.298828,1.837891 -0.903123,0.174231 -2.024654,-0.01568 -3.30664,-0.802734 0.146918,-0.408275 0.03575,-0.877123 -0.326172,-1.15625 -0.448852,-0.346175 -1.093279,-0.263302 -1.439453,0.185546 -0.346175,0.448852 -0.263306,1.093279 0.185547,1.439454 0.392164,0.302454 0.923606,0.259825 1.285156,-0.05078 1.38158,0.853941 2.645095,1.092033 3.699218,0.888672 1.254223,-0.241963 2.188855,-1.090073 2.667969,-2.126953 0.479118,-1.036884 0.512882,-2.273597 -0.03516,-3.3125 -0.435797,-0.826121 -1.24979,-1.504147 -2.447266,-1.851563 -0.02705,-0.490339 -0.382485,-0.908987 -0.886718,-0.966796 z",
    transform: "matrix(2.9214746,0,0,2.9214746,90.539143,186.24328)",
    id: "path4672"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g6139"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ff0000",
      strokeWidth: 1.5
    },
    id: "g14492",
    transform: "translate(145.23943,18.797378)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g5901"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5929"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path8087",
    transform: "matrix(2.9214746,0,0,2.9214746,91.817583,186.24328)",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 43.019531,78.679688 c -0.262853,0 -0.526157,0.100373 -0.726562,0.300781 -0.400815,0.400814 -0.400815,1.052313 0,1.453125 0.130097,0.130098 0.289431,0.202404 0.455078,0.248047 l 0,4.822265 c -0.439137,0.116538 -0.769531,0.500919 -0.769531,0.976563 0,0.566837 0.460506,1.027343 1.027343,1.027343 0.566837,0 1.025391,-0.460506 1.025391,-1.027343 0,-0.475882 -0.330059,-0.860251 -0.769531,-0.976563 l 0,-4.816406 c 0.176397,-0.04309 0.346681,-0.116212 0.484375,-0.253906 0.130098,-0.130098 0.202404,-0.289431 0.248047,-0.455078 l 1.728515,0 c 0.116583,0.43907 0.499014,0.769531 0.97461,0.769531 0.566837,0 1.027343,-0.460507 1.027343,-1.027344 0,-0.566837 -0.460506,-1.025391 -1.027343,-1.025391 -0.475834,0 -0.858252,0.330127 -0.97461,0.769532 l -1.722656,0 c -0.04309,-0.176398 -0.116212,-0.346681 -0.253906,-0.484375 -0.200408,-0.200408 -0.46371,-0.300781 -0.726563,-0.300781 z m 0.02344,-3.361329 c -0.56543,0.0399 -0.99107,0.532226 -0.951172,1.097657 0.0399,0.56543 0.530269,0.991069 1.095703,0.951172 0.460273,-0.03248 0.814539,-0.367721 0.914062,-0.794922 0.641318,-0.0074 1.63222,-0.0047 3.109376,0.03711 1.428056,0.137044 2.517313,1.499237 2.626953,2.927734 0.05485,0.714609 -0.12894,1.433903 -0.628907,2.033203 -0.36053,0.432161 -0.897468,0.80244 -1.638672,1.058594 -0.206165,-0.368574 -0.618643,-0.592342 -1.058593,-0.517578 -0.558828,0.09497 -0.934806,0.626723 -0.839844,1.185547 0.09497,0.558827 0.624766,0.934806 1.183594,0.839844 0.495984,-0.08429 0.827412,-0.516171 0.833984,-1.001953 0.844286,-0.28337 1.478932,-0.712795 1.914063,-1.234375 0.59038,-0.707674 0.811778,-1.571962 0.748046,-2.402344 -0.127469,-1.660757 -1.372982,-3.236788 -3.09375,-3.400391 l -0.0078,-0.002 -0.0078,0 c -1.497232,-0.04278 -2.50717,-0.0449 -3.160157,-0.03711 -0.134229,-0.451114 -0.550222,-0.774728 -1.039062,-0.740235 z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ff0000",
      strokeWidth: 1.5
    },
    id: "g14538",
    transform: "translate(143.79853,18.797378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5641"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 52.705078,75.298828 c -0.566837,0 -1.027344,0.460507 -1.027344,1.027344 0,0.475596 0.330461,0.858026 0.769532,0.974609 l 0,8.208985 c -0.175573,0.04331 -0.345311,0.114842 -0.482422,0.251953 -0.400815,0.400814 -0.400815,1.052313 0,1.453125 0.400814,0.400814 1.05036,0.400814 1.451172,0 0.130032,-0.130031 0.202384,-0.289526 0.248046,-0.455078 l 4.78711,0 c 0.116538,0.439136 0.500919,0.769531 0.976562,0.769531 0.566837,0 1.025391,-0.460507 1.025391,-1.027344 0,-0.566837 -0.458554,-1.025391 -1.025391,-1.025391 -0.475881,10e-7 -0.86025,0.33006 -0.976562,0.769532 l -4.78125,0 C 53.626811,86.06978 53.55365,85.899353 53.416016,85.761719 53.285772,85.631474 53.126791,85.559271 52.960938,85.513672 l 0,-8.212891 c 0.440004,-0.115952 0.771484,-0.49835 0.771484,-0.974609 0,-0.566837 -0.460507,-1.027344 -1.027344,-1.027344 z m 6.75586,0.05859 c -0.475882,0 -0.860251,0.332012 -0.976563,0.771484 l -2.318359,0 0,1.205078 c -0.440073,0.115906 -0.771485,0.498302 -0.771485,0.97461 0,0.566837 0.460507,1.027344 1.027344,1.027344 0.566837,0 1.027344,-0.460507 1.027344,-1.027344 0,-0.476308 -0.331412,-0.858704 -0.771485,-0.97461 l 0,-0.691406 1.806641,0 c 0.116538,0.439137 0.500919,0.769531 0.976563,0.769531 0.566837,0 1.02539,-0.460506 1.02539,-1.027343 0,-0.566837 -0.458553,-1.027344 -1.02539,-1.027344 z m 0,4.992187 c -0.476308,0 -0.860657,0.331412 -0.976563,0.771485 l -2.318359,0 0,1.205078 c -0.440073,0.115906 -0.771485,0.498301 -0.771485,0.974609 0,0.566837 0.460507,1.027344 1.027344,1.027344 0.566837,0 1.027344,-0.460507 1.027344,-1.027344 0,-0.476308 -0.331412,-0.858703 -0.771485,-0.974609 l 0,-0.691406 1.806641,0 c 0.116538,0.439136 0.500919,0.769531 0.976563,0.769531 0.566837,0 1.02539,-0.460507 1.02539,-1.027344 0,-0.566837 -0.458553,-1.027344 -1.02539,-1.027344 z",
    transform: "matrix(2.9214746,0,0,2.9214746,93.258483,186.24328)",
    id: "path8909"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g5675"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g5665"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ff0000",
      strokeWidth: 1.5
    },
    id: "g14567",
    transform: "translate(143.3526,18.797378)"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g5369"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5391"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path11012",
    transform: "matrix(2.9214746,0,0,2.9214746,93.704413,186.24328)",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 67.755859,78.710938 c -0.399979,0.0121 -0.773961,0.257955 -0.927734,0.654296 -0.002,0.0051 -6.6e-5,0.01053 -0.002,0.01563 -0.799764,0.121895 -1.42371,0.723319 -1.621094,1.408203 -0.06344,0.01996 -0.128929,0.0254 -0.189453,0.05859 -0.496999,0.272575 -0.678825,0.895579 -0.40625,1.392578 0.272571,0.496996 0.895579,0.680778 1.392578,0.408204 0.496999,-0.272572 0.678821,-0.897533 0.40625,-1.394532 -0.140353,-0.255913 -0.373226,-0.424283 -0.634765,-0.49414 0.176009,-0.392967 0.53663,-0.746248 1.015624,-0.859375 0.05774,0.345916 0.274551,0.657001 0.625,0.792968 0.52846,0.205034 1.123092,-0.05748 1.328126,-0.585937 0.20503,-0.528459 -0.05748,-1.123092 -0.585938,-1.328125 -0.132114,-0.05126 -0.267064,-0.07239 -0.400391,-0.06836 z m 0.07422,-3.386719 c -0.500152,-0.02084 -0.915023,0.328738 -1.02539,0.798828 -3.142574,0.285522 -4.92906,2.616535 -5.011719,5.03125 -0.08312,2.428179 1.56213,4.922281 5,5.484375 0.07067,0.474678 0.447845,0.856799 0.945312,0.880859 0.566173,0.0274 1.048789,-0.410386 1.076172,-0.976562 0.0274,-0.566173 -0.410386,-1.048789 -0.976562,-1.076172 -0.453301,-0.02193 -0.83894,0.260643 -0.994141,0.662109 -3.211835,-0.524591 -4.611878,-2.772846 -4.537109,-4.957031 0.07429,-2.170072 1.608171,-4.268861 4.505859,-4.537109 0.120119,0.411194 0.480101,0.723384 0.931641,0.742187 0.566344,0.0236 1.044775,-0.418031 1.068359,-0.984375 0.0236,-0.566347 -0.416078,-1.044775 -0.982422,-1.068359 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g5119"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 74.890625,75.300781 c -0.262853,0 -0.526155,0.100374 -0.726563,0.300781 -0.137111,0.137112 -0.208648,0.30685 -0.251953,0.482422 l -1.6875,0 C 72.108027,75.644914 71.725596,75.314453 71.25,75.314453 c -0.566837,0 -1.027344,0.460507 -1.027344,1.027344 0,0.566837 0.460507,1.027344 1.027344,1.027344 0.476259,0 0.858657,-0.331481 0.974609,-0.771485 l 1.691407,0 c 0.0456,0.165854 0.117802,0.324835 0.248046,0.455078 0.137635,0.137635 0.308062,0.210796 0.484376,0.253907 l 0,8.207031 c -0.165647,0.04564 -0.324981,0.117948 -0.455079,0.248047 -0.137694,0.137694 -0.210817,0.307977 -0.253906,0.484375 l -1.675781,0 C 72.21803,86.080447 72.145724,85.921113 72.015625,85.791016 71.877931,85.653321 71.707648,85.580198 71.53125,85.537109 l 0,-4.832031 c 0.439404,-0.116357 0.769531,-0.498776 0.769531,-0.974609 0,-0.566837 -0.458553,-1.027344 -1.02539,-1.027344 -0.566837,0 -1.027344,0.460507 -1.027344,1.027344 0,0.475596 0.330461,0.858026 0.769531,0.974609 l 0,4.837891 c -0.165647,0.04564 -0.32498,0.117948 -0.455078,0.248047 -0.400815,0.400811 -0.400815,1.05231 0,1.453125 0.400811,0.400814 1.05231,0.400814 1.453125,0 0.137694,-0.137695 0.210818,-0.307978 0.253906,-0.484375 l 1.675781,0 c 0.04564,0.165647 0.117949,0.32498 0.248047,0.455078 0.400812,0.400814 1.052311,0.400814 1.453125,0 0.400815,-0.400812 0.400815,-1.052311 0,-1.453125 -0.137694,-0.137694 -0.307977,-0.210818 -0.484375,-0.253907 l 0,-8.207031 c 0.165553,-0.04566 0.325048,-0.118015 0.455079,-0.248047 0.400814,-0.400811 0.400814,-1.050357 0,-1.451172 -0.200406,-0.200407 -0.46371,-0.300781 -0.726563,-0.300781 z",
    transform: "matrix(2.9214746,0,0,2.9214746,237.05701,205.04066)",
    id: "path12080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5085"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 83.550781,75.320312 c -0.56683,-0.0032 -1.030122,0.454655 -1.033203,1.021485 -0.0017,0.311285 0.143406,0.58188 0.361328,0.771484 l -2.617187,5.033203 c -0.246358,-0.05185 -0.510179,-0.01978 -0.742188,0.121094 -0.484515,0.294191 -0.639897,0.925641 -0.345703,1.410156 0.294194,0.484516 0.925641,0.639894 1.410156,0.345704 0.24346,-0.147827 0.403099,-0.381832 0.464844,-0.638672 l 1.5625,0 c 0.116583,0.43907 0.499013,0.769531 0.97461,0.769531 0.566837,0 1.027343,-0.460507 1.027343,-1.027344 0,-0.566837 -0.460506,-1.025391 -1.027343,-1.025391 -0.475834,0 -0.858252,0.330127 -0.97461,0.769532 l -1.58789,0 c -0.02466,-0.08786 -0.04409,-0.177976 -0.09375,-0.259766 -0.0561,-0.0924 -0.133633,-0.160947 -0.210938,-0.228516 l 2.623047,-5.048828 c 0.06611,0.01378 0.127147,0.04063 0.197265,0.04102 0.08303,4.65e-4 0.156934,-0.02868 0.234376,-0.04687 l 4.255859,8.414063 c -0.06848,0.06283 -0.140334,0.122018 -0.191406,0.205078 -0.05792,0.09419 -0.08468,0.196829 -0.109375,0.298828 l -8.34961,0 c -0.116357,-0.439405 -0.498776,-0.769532 -0.974609,-0.769532 -0.566837,0 -1.027344,0.458554 -1.027344,1.025391 0,0.566837 0.460507,1.027344 1.027344,1.027344 0.475596,0 0.858026,-0.330461 0.974609,-0.769531 l 8.351563,0 c 0.06738,0.23992 0.2145,0.458886 0.443359,0.599609 0.482859,0.296905 1.115205,0.146918 1.41211,-0.335937 0.296908,-0.482859 0.146917,-1.115205 -0.335938,-1.41211 -0.241429,-0.148452 -0.519707,-0.185973 -0.775391,-0.125 l -4.240234,-8.384766 c 0.204054,-0.186499 0.336271,-0.450034 0.337891,-0.748046 0.0032,-0.566827 -0.454658,-1.030123 -1.021485,-1.033204 z",
    transform: "matrix(2.9214746,0,0,2.9214746,237.05701,205.04066)",
    id: "path12584"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4834"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 95.826172,75.296875 c -0.262853,0 -0.526155,0.100374 -0.726563,0.300781 -0.137291,0.137291 -0.208714,0.306595 -0.251953,0.482422 l -1.677734,0 c -0.04566,-0.165553 -0.118015,-0.323094 -0.248047,-0.453125 -0.400811,-0.400815 -1.050357,-0.400815 -1.451172,0 -0.400815,0.400811 -0.400815,1.050357 0,1.451172 0.137635,0.137635 0.306109,0.210796 0.482422,0.253906 l 0,8.207031 c -0.165647,0.04564 -0.324981,0.117949 -0.455078,0.248047 -0.400815,0.400812 -0.400815,1.052311 0,1.453125 0.400811,0.400815 1.05231,0.400815 1.453125,0 0.137694,-0.137694 0.210818,-0.307977 0.253906,-0.484375 l 5.103516,0 c 0.116538,0.439137 0.500919,0.769532 0.976562,0.769532 0.566837,0 1.025394,-0.460507 1.025394,-1.027344 0,-0.566837 -0.458557,-1.025391 -1.025394,-1.025391 -0.475881,0 -0.86025,0.330059 -0.976562,0.769532 l -5.109375,0 c -0.04564,-0.165647 -0.117948,-0.324981 -0.248047,-0.455079 -0.137694,-0.137694 -0.307977,-0.210817 -0.484375,-0.253906 l 0,-8.207031 c 0.165553,-0.04566 0.325047,-0.118015 0.455078,-0.248047 0.137635,-0.137635 0.210796,-0.308062 0.253906,-0.484375 l 1.675781,0 c 0.04564,0.165647 0.117949,0.324981 0.248047,0.455078 0.137635,0.137635 0.308062,0.210796 0.484375,0.253906 l 0,4.832032 c -0.439136,0.116538 -0.769531,0.498966 -0.769531,0.974609 0,0.566837 0.460507,1.027344 1.027344,1.027344 0.566837,0 1.025391,-0.460507 1.025391,-1.027344 0,-0.475882 -0.33006,-0.858298 -0.769532,-0.974609 l 0,-4.837891 c 0.165553,-0.04566 0.325047,-0.118015 0.455078,-0.248047 0.400815,-0.400811 0.400815,-1.050357 0,-1.451172 -0.200405,-0.200407 -0.463709,-0.300781 -0.726562,-0.300781 z",
    transform: "matrix(2.9214746,0,0,2.9214746,237.05701,205.04066)",
    id: "path12080-1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ff0000",
      strokeWidth: 1.5
    },
    transform: "translate(350.54448,18.800114)",
    id: "g13935-6"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g4560"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4582"
  }, /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4672-9-0",
    transform: "matrix(2.9214746,0,0,2.9214746,-113.48747,186.24055)",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 106.42383,78.697266 c -0.56315,-0.06457 -1.07215,0.341149 -1.13672,0.904296 -0.0646,0.563151 0.3392,1.072156 0.90234,1.136719 0.44226,0.0507 0.84275,-0.192738 1.0293,-0.570312 1.0545,0.313051 1.72172,0.897463 2.08594,1.58789 0.46495,0.881394 0.44116,1.953413 0.0234,2.857422 -0.41772,0.904009 -1.21837,1.629075 -2.30078,1.837891 -0.90326,0.174257 -2.02245,-0.01537 -3.30468,-0.802734 0.14626,-0.40801 0.0354,-0.877389 -0.32618,-1.15625 -0.44885,-0.346175 -1.09327,-0.263302 -1.43945,0.185546 -0.34617,0.448852 -0.2633,1.095232 0.18555,1.441407 0.39178,0.302157 0.92165,0.258961 1.2832,-0.05078 1.38199,0.854476 2.64483,1.092084 3.69922,0.888672 1.25422,-0.241963 2.18885,-1.092026 2.66797,-2.128906 0.47912,-1.036884 0.51483,-2.271643 -0.0332,-3.310547 -0.43582,-0.826162 -1.2497,-1.506116 -2.44727,-1.853516 -0.0279,-0.489525 -0.38508,-0.909061 -0.88867,-0.966796 z m -0.43945,-2.810547 c -0.33719,0.0205 -0.6558,0.0808 -0.95313,0.177734 -1.18931,0.387726 -2.02094,1.330841 -2.40625,2.40625 -0.38531,1.075406 -0.33482,2.296191 0.25977,3.263672 0.46574,0.757842 1.27604,1.335675 2.41406,1.552734 0.0792,0.488275 0.48361,0.869141 0.99414,0.869141 0.56684,0 1.02734,-0.460507 1.02734,-1.027344 0,-0.566837 -0.4605,-1.027344 -1.02734,-1.027344 -0.44239,0 -0.81072,0.283274 -0.95508,0.675782 -0.98367,-0.195192 -1.63149,-0.685506 -2.01562,-1.310547 -0.49945,-0.812686 -0.55154,-1.877092 -0.21289,-2.822266 0.33864,-0.945177 1.05701,-1.75827 2.08007,-2.091797 0.84431,-0.275248 1.91495,-0.223015 3.1836,0.378907 -0.10299,0.41833 0.0529,0.871668 0.4375,1.113281 0.47998,0.301526 1.11448,0.155768 1.41601,-0.324219 0.30153,-0.479984 0.15577,-1.114486 -0.32422,-1.416015 -0.42019,-0.263969 -0.94546,-0.167853 -1.27539,0.177734 -0.96609,-0.46223 -1.85696,-0.643476 -2.64257,-0.595703 z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItspecials);
export default __webpack_public_path__ + "static/media/itspecials.8b8d0308f2d0a0d938eae3f6fcc2e22c.svg";
export { ForwardRef as ReactComponent };